import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CLINIC = {
  name: "Tooth Buds Pediatric Dental Clinic",
  doctor: "Dr. Anuj Shah",
  phone: "+91 98206 49411",
  phoneRaw: "+919820649411",
  whatsapp: "https://wa.me/919820649411?text=Hi%20Tooth%20Buds%2C%20I%27d%20like%20to%20know%20more%20about%20an%20appointment",
  address: "3, Jimit Apartment, Marve Rd, next to New India Co-op Bank, Adarsh Nagar, Malad West, Mumbai 400064",
  maps: "https://maps.app.goo.gl/QiK4gQtqqixTfUJr5",
  mapEmbed: "https://www.google.com/maps?q=Tooth+Buds+Dental+Clinic,+Marve+Rd,+Malad+West,+Mumbai&output=embed",
  rating: "5.0",
  reviewCount: 36,
};

export const SERVICES = [
  "First Visit & Check-up", "Cleaning & Fluoride", "Cavity Fillings", "Root Canal (Pulpectomy)",
  "Crowns for Kids", "Tooth Extraction", "Braces & Orthodontics", "Dental Emergency",
  "Special Needs Care", "Other / Not sure",
];

export const fmtDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

export const fmtTime = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};

export const errMsg = (e) => e?.response?.data?.detail?.toString?.() || "Something went wrong. Please try again.";

export const ADMIN_TOKEN_KEY = "tb_admin_token";
const isAdminUrl = (url) => url.startsWith("/admin") || url.startsWith("/users") || url === "/doctor";

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const adminTok = localStorage.getItem(ADMIN_TOKEN_KEY);
    const token = adminTok && isAdminUrl(url) ? adminTok : await getToken();
    const res = await axios({ method, url: `${API}${url}`, data, headers: token ? { Authorization: `Bearer ${token}` } : {} });
    return res.data;
  }, [getToken]);
}
